module.exports = __webpack_public_path__ + "media/images/aloe/icons/categories/accessories-f26e711f2bc30838052b306489e8c5cc.svg";